import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { notification } from 'antd';
import { compose } from 'redux';
import { pending } from 'redux-saga-thunk';
import { reduxForm, reset } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { modalHide, modalShow } from '../store/modal/actions';
import { isOpen } from '../store/modal/selectors';
import { createValidator, maxSize, minSize, required, url } from '../services/validation';
import CreativeFormModal from '../components/organisms/CreativeFormModal';
import { emptyEditRecord } from '../store/updateCreative/actions';
import {
  resourceCreateRequest,
  resourceDetailReadRequest,
  resourceUpdateRequest,
} from '../store/resource/actions';
import { fromEntities } from '../store/selectors';
import E2Preview from './E2Preview';

class CreativeFormModalContainer extends Component {
  componentDidUpdate = prevProps => {
    if (
      this.props.visible &&
      get(this.props, 'activeCreative.creative_service_id', false) !== false &&
      this.props.activeCreative.creative_service_id !== prevProps.activeCreative.creative_service_id
    ) {
      this.props.getCreative(this.props.activeCreative.creative_service_id);
    }
  };

  render() {
    return (
      <>
        <E2Preview />
        <CreativeFormModal {...this.props} />
      </>
    );
  }
}

const mapStateToProps = (
  { modal, updateCreative, ...state },
  {
    match: {
      params: { lineItemId },
    },
  }
) => {
  const activeCreative = fromEntities.getDetail(
    state,
    'adminCreative',
    updateCreative.creative_service_id
  );

  return {
    lineItemId,
    activeCreative,
    loading: pending(state, 'advertiserAdCreative'),
    visible: isOpen(modal, 'create-creative'),
    isEdit: !isEmpty(activeCreative),
    initialValues: {
      creative_type: 'custom_url',
      ...updateCreative,
      ...activeCreative,
    },
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { campaignId },
    },
  }
) => ({
  showE2PreviewModal: () => dispatch(modalShow('e2-preview')),
  getCreative: id =>
    dispatch(
      resourceDetailReadRequest(
        `${process.env.REACT_APP_INMARKET_CREATIVE_API}/admin/creative/:id`,
        {
          id,
        }
      )
    ),
  createCreative: data =>
    dispatch(
      resourceCreateRequest(
        `${process.env.REACT_APP_INMARKET_CREATIVE_API}/admin/creative`,
        {},
        { ...data, campaign_id: parseInt(campaignId, 10) }
      )
    ),
  updateCreative: data =>
    dispatch(
      resourceUpdateRequest(
        `${process.env.REACT_APP_INMARKET_CREATIVE_API}/admin/creative/:id`,
        { id: data.creative_service_id },
        { ...data, campaign_id: parseInt(campaignId, 10) }
      )
    ),
  onCancel: () => {
    dispatch(modalHide('create-creative'));

    // Timeout because hiding is a slow fade.
    // We don't want to flash the form resetting
    setTimeout(() => dispatch(emptyEditRecord()), 100);
  },
});

const onSubmit = (values, dispatch, props) => {
  if (!props.isEdit) {
    return props
      .createCreative(values)
      .then(() => {
        dispatch(reset('CreativeForm'));
        props.onCancel();
      })
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not create creative.',
          duration: 0,
        });
      });
  }

  return props
    .updateCreative(values)
    .then(() => {
      props.onCancel();
      notification.success({ message: 'Success', description: 'Creative updated.', duration: 4 });
    })
    .catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not update creative.',
        duration: 0,
      });
    });
};
const validate = createValidator({
  name: [required],
  descr: [required],
  prefix_len: [minSize(0), maxSize(12)],
  cat_id: [required],
  creative_html: [required],
  click_through_url: [url],
  creative_image: [required, url],
  creative_url: [required, url],
  url_image: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'CreativeForm',
    onSubmit,
    enableReinitialize: true,
    validate,
  })
)(CreativeFormModalContainer);
